export default __webpack_public_path__ + "static/media/11769_KS2_SM1_USA_Peach-3_3_T-1_2018b.2298af3d.gif";